// The special characters the design lists, escaped for a character class
const SPECIAL = /[!@£$%^&*()_\-<>?]/;
export function passwordRules(password) {
    return [
        { label: 'At least 8 characters', met: password.length >= 8 },
        { label: 'At least 1 number', met: /[0-9]/.test(password) },
        { label: 'At least 1 special character (!@£$%^&*()_-<>?)', met: SPECIAL.test(password) },
    ];
}
export function passwordIsValid(password) {
    return passwordRules(password).every((rule) => rule.met);
}
